import { StandardDirectoryViewColumnName } from '@townsquare/directory-view-store/types';
import { logger } from '@townsquare/logging/logger';

import { ColumnInfo } from '../types';

const urlColumnToDirectoryViewColumnMap: Record<string, StandardDirectoryViewColumnName> = {
	contributors: 'CONTRIBUTORS',
	followerCount: 'FOLLOWER_COUNT',
	following: 'FOLLOWING',
	goals: 'GOALS',
	lastUpdated: 'LAST_UPDATED',
	owner: 'OWNER',
	progress: 'PROGRESS',
	relatedProjects: 'RELATED_PROJECTS',
	status: 'STATUS',
	tags: 'TAGS',
	startDate: 'START_DATE',
	targetDate: 'TARGET_DATE',
	team: 'TEAMS',
	focusArea: 'FOCUS_AREA',
};

const urlColumnToDirectoryViewColumn = (columnId: string): StandardDirectoryViewColumnName => {
	const directoryViewColumn = urlColumnToDirectoryViewColumnMap[columnId];
	if (!directoryViewColumn) {
		logger.info(`Unknown column id: ${columnId}`);
	}

	return directoryViewColumn;
};

export const shownColumnsToDirectoryViewColumns = (columns: ColumnInfo[]): ({
    standardFieldName: StandardDirectoryViewColumnName;
} | {
    customFieldUuid: string;
})[] => {
	const standardFieldIds = columns
		.filter(c => !c.locked && !c.custom)
		.map(({ id }) => urlColumnToDirectoryViewColumn(id))
		.map(id => ({ standardFieldName: id }));

	const customFieldIds = columns.filter(c => !c.locked && !!c.custom).map(c => ({ customFieldUuid: c.id }));

	return [...standardFieldIds, ...customFieldIds];
};

const directoryViewColumnToUrlColumnMap: Record<string, string> = {
	CONTRIBUTORS: 'contributors',
	FOLLOWER_COUNT: 'followerCount',
	FOLLOWING: 'following',
	GOALS: 'goals',
	LAST_UPDATED: 'lastUpdated',
	OWNER: 'owner',
	PROGRESS: 'progress',
	RELATED_PROJECTS: 'relatedProjects',
	STATUS: 'status',
	TAGS: 'tags',
	START_DATE: 'startDate',
	TARGET_DATE: 'targetDate',
	TEAMS: 'team',
	FOCUS_AREA: 'focusArea',
};

export const directoryViewColumnToUrlColumn = (column: string): string => {
	return directoryViewColumnToUrlColumnMap[column] ?? column;
};

export const columnToWidthFormat = (
	column: ColumnInfo,
): 'user' | 'userMulti' | 'number' | 'textSelect' | 'textSelectMulti' | 'text' | string => {
	if (column.custom) {
		switch (column.type) {
			case 'USER':
				if (column.isMulti) {
					return 'userMulti';
				}
				return 'user';
			case 'NUMBER':
				return 'number';
			case 'TEXT_SELECT':
				if (column.isMulti) {
					return 'textSelectMulti';
				}
				return 'textSelect';
			case 'TEXT':
			default:
				return 'text';
		}
	}

	return column.id;
};
